import { useState } from "preact/hooks";
import { audio, type AudioSettings as Levels } from "../audio/engine.ts";

const SLIDERS: [keyof Levels, string, string][] = [
  ["master", "Master", "Everything"],
  ["effects", "Effects", "Weapons, abilities, footsteps, hit sounds"],
  ["voice", "Announcer", "Objective and match callouts"],
  ["music", "Music", "Hero themes, stingers, overtime"],
];

/** Per-player volume sliders; saved on this device. Releasing a slider previews that sound. */
export function AudioSettings() {
  const [s, setS] = useState<Levels>(audio.settings);
  const set = (k: keyof Levels, v: number) => {
    audio.setSettings({ [k]: v });
    setS({ ...audio.settings });
  };
  return (
    <section class="audio-grid" aria-label="Audio">
      <div class="eyebrow">Audio · saved on this device</div>
      {SLIDERS.map(([k, label, hint]) => (
        <div class="slider" key={k}>
          <label for={`vol-${k}`} title={hint}>
            {label}
            <output for={`vol-${k}`}>{Math.round(s[k] * 100)}%</output>
          </label>
          <input
            id={`vol-${k}`}
            type="range"
            min={0}
            max={1}
            step={0.05}
            value={s[k]}
            data-preview={k}
            aria-describedby={`vol-${k}-hint`}
            onInput={(e) => set(k, Number(e.currentTarget.value))}
          />
          <small id={`vol-${k}-hint`}>{hint}</small>
        </div>
      ))}
    </section>
  );
}
